// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { cookieStorage } from '@/lib/cookieStorage';

const SUPABASE_URL = "https://uhtgcidyxprykowgsahq.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVodGdjaWR5eHByeWtvd2dzYWhxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM4Mjk4NTQsImV4cCI6MjA2OTQwNTg1NH0.AZmsKDhZQ-UTlis1nyeNN38u1QQErUuzMVGZnS6bvpU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: cookieStorage, // Use cookie storage for cross-subdomain auth
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false, // Disable URL token parsing for cookie-based auth
  },
  global: {
    headers: {
      'X-Client-Info': 'team-bluelux-app',
    },
  },
});